import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _global$window;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from 'axios';
import get from 'lodash/fp/get';
import { createQueryString } from '../../../../util/urlUtil';
import { GENERIC_ERROR_MESSAGE } from '../formActionUtils';
import { getQueryUtmParams } from '../../../../../client/analytics/utmUtil';
import { determineSessionArrivalAvenue, getPersistedSessionArrivalAvenue } from './registrationUtils';
import { sendRegisterSubmitEvent, sendRegisterSuccessEvent } from '../../../../../client/analytics/dataLayerService';
import { REGISTRATION_SOURCES } from '../../../../../client/analytics/dataLayerConstants';
import { getPlatformDetails } from './platformUtils';
var config = (_global$window = global.window) === null || _global$window === void 0 ? void 0 : _global$window.__config;
export var CookieGroupIds = {
  // These cookies are necessary for the website to function and cannot be switched off in our systems.
  STRICTLY_NECESSARY_COOKIES: 'C0001',
  // These cookies allow us to count visits and traffic sources so we can measure and improve the
  // performance of our site.
  PERFORMANCE_COOKIES: 'C0002',
  // These cookies enable the website to provide enhanced functionality and personalisation.
  FUNCTIONAL_COOKIES: 'C0003',
  // These cookies may be set through our site by our advertising partners.
  TARGETING_COOKIES: 'C0004'
};
var getAmplitudeDeviceId = get(['options', 'deviceId']);
var getConsentSettings = function getConsentSettings() {
  var consent = window.OnetrustActiveGroups || '';
  return Object.values(CookieGroupIds).reduce(function (acc, id) {
    acc[id] = consent.indexOf(",".concat(id, ",")) > -1;
    return acc;
  }, {});
};
export var submitForm = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
    var successRedirect, onboarding, segments, utm, registrationAvenue, _getPlatformDetails, platform, appMode, formData, _yield$axios$post, _yield$axios$post$dat, token, userId, eventId, params;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          successRedirect = values.successRedirect, onboarding = values.onboarding, segments = values.segments;
          utm = getQueryUtmParams(window.location); // Use this `reset_` prefix if the persisted arrival is empty -- hunting down an Amplitude issue
          // where some users are showing up with blank arrival avenues. (WEB-15082)
          registrationAvenue = getPersistedSessionArrivalAvenue() || "reset_".concat(determineSessionArrivalAvenue());
          _getPlatformDetails = getPlatformDetails(), platform = _getPlatformDetails.platform, appMode = _getPlatformDetails.appMode;
          formData = _objectSpread(_objectSpread({
            utm: utm
          }, values), {}, {
            amplitudeDeviceId: getAmplitudeDeviceId(window.amplitude && window.amplitude.getInstance()),
            registrationAvenue: registrationAvenue,
            onboarding: onboarding,
            segments: segments,
            platform: platform,
            appMode: appMode,
            consentSettings: getConsentSettings()
          });
          sendRegisterSubmitEvent(REGISTRATION_SOURCES.FORM);
          _context.next = 1;
          return axios.post("".concat(config.appUrl, "/api/auth/register"), formData, {
            withCredentials: true
          });
        case 1:
          _yield$axios$post = _context.sent;
          _yield$axios$post$dat = _yield$axios$post.data;
          token = _yield$axios$post$dat.token;
          userId = _yield$axios$post$dat.userId;
          eventId = _yield$axios$post$dat.eventId;
          if (token) {
            _context.next = 2;
            break;
          }
          throw new Error(GENERIC_ERROR_MESSAGE);
        case 2:
          params = {
            token: token
          };
          if (successRedirect) {
            params.success_redirect = encodeURIComponent(successRedirect);
          }
          sendRegisterSuccessEvent({
            userId: userId,
            eventId: eventId
          });
          window.location = "".concat(config.appUrl, "/register-success/").concat(createQueryString(params));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function submitForm(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchInvitationEmail = function fetchInvitationEmail(inviteCode) {
  return axios.get("".concat(config.appUrl, "/api/invite/").concat(inviteCode)).then(function (response) {
    return response.data.email;
  })["catch"](function (err) {
    return null;
  });
};